import { useState } from 'react';
import {
  Button,
  Card,
  Error,
  LoadingStatus,
  Modal,
  WarningStatus,
} from '@/components/generic';
import { cn } from '@/lib/utils';
import { useHandleMFA, useRecoveryKeys } from '@package/smart-wallet/hooks';
import { useTranslation } from 'react-i18next';

const PrivateKey = () => {
  const { t } = useTranslation();
  const { isLoading, handleExportKey, error } = useRecoveryKeys();
  const { isGettingMFAStatus, isMFAEnabled } = useHandleMFA();
  const [isWarningVisible, setIsWarningVisible] = useState(false);
  const handlerExportKey = () => {
    setIsWarningVisible(false);
    if (isMFAEnabled) {
      handleExportKey();
    }
  };
  return (
    <>
      <Modal open={isWarningVisible} onClose={() => setIsWarningVisible(false)}>
        <WarningStatus
          content={
            isMFAEnabled
              ? `Are you sure you want to export your ${t('profile.private_key.recovery_keys').toLowerCase()}?`
              : 'You have MFA enabled. Please confirm your action.'
          }
          onClose={() => setIsWarningVisible(false)}
          confirm={() => handlerExportKey()}
        />
      </Modal>
      <Card title={t('profile.private_key.title')} className='m-0'>
        {isLoading || isGettingMFAStatus ? (
          <LoadingStatus />
        ) : (
          <form className='flex flex-col gap-8 p-5 pt-0 max-lg:px-3 max-md:gap-4'>
            <Button
              className={cn(
                'w-full cursor-pointer uppercase',
                isLoading && 'cursor-not-allowed',
              )}
              onClick={() => setIsWarningVisible(true)}
              type='button'
              disabled={isLoading || isGettingMFAStatus}
            >
              {t('profile.private_key.recovery_keys')}
            </Button>
          </form>
        )}
        <Error
          error={error}
          message={
            error ||
            'An error occurred while exporting recovery keys. Please try again later.'
          }
        />
      </Card>
    </>
  );
};

export default PrivateKey;
